import { observable, action, makeObservable } from 'mobx';
import { Stomp, CompatClient } from '@stomp/stompjs';
import { elkLog } from '@/utils/elkReport';

const REDELAY = 5000;

export enum SUBSCRIBE_TYPT {
  barrage,
  transcribe,
}
class StompInstance {
  constructor() {
    makeObservable(this);
  }

  @observable startedConnected = false;

  @observable connected = false;

  @observable client: CompatClient | null = null;

  @observable responseBody: Map<
    SUBSCRIBE_TYPT,
    {
      body: string;
      commandId: number;
      channelId: number;
      sender: string;
      serviceId: number;
      timestamp: number;
    } | null
  > = new Map();

  @action
  setStartedConnected(linked: boolean) {
    this.startedConnected = linked;
  }

  @action
  stompConnect(url: string) {
    if (!this.client) {
      this.client = Stomp.client(url);
      this.client.reconnect_delay = REDELAY;
    } else {
      return;
    }
    // const urlObj = new URL(url);
    // this.client = Stomp.client(url?.replace(urlObj.origin, 'ws://10.219.152.59:10012'));
    elkLog('web转录', { dataType: 'stompConnect' }, { url });
    let heartbeatTimer: number;
    const heartbeat = () => {
      heartbeatTimer && window.clearInterval(heartbeatTimer);
      heartbeatTimer = window.setInterval(() => {
        this.client?.publish({
          destination: `/heart-beat`,
        });
      }, 30 * 1000);
    };
    const successCallback = () => {
      if (!this.client) return;
      this.connected = true;
      heartbeat();
      elkLog('pc转录', { dataType: 'stompSubscribe' }, {});
    };
    const errorCallback = () => {
      // 连接失败时（服务器响应 CONNECTED 帧）的回调方法
      // eslint-disable-next-line no-use-before-define
      setTimeout(connect, REDELAY);
    };
    const closeCallback = (e: any) => {
      heartbeatTimer && window.clearInterval(heartbeatTimer);
      this.client = null;
      return e;
    };
    // 向服务器发起websocket连接并发送CONNECT帧
    const connect = () => {
      this.client?.connect({ deviceType: 'web' }, successCallback, errorCallback, closeCallback);
    };
    connect();
  }

  @action
  async connect(getStompDestination: any, type: SUBSCRIBE_TYPT) {
    getStompDestination().then((res: any) => {
      const { stompDestination, stompEndpoint } = res;
      this.stompConnect(stompEndpoint);
    });
  }

  @action initConnect(fn: any) {
    fn().then((res: any) => {
      const stompEndpoint = res?.data?.stompEndpoint;
      if (stompEndpoint) {
        this.stompConnect(stompEndpoint);
      }
    });
  }

  @action subscribe(subString: string, callback: any, subscriptionId: string) {
    if (this.connected && this.client) {
      this.client.subscribe(
        subString,
        (response) => {
          callback(JSON.parse(response.body));
        },
        { id: subscriptionId }
      );
    }
  }

  @action unSubscribe(subscriptionId: string | undefined) {
    if (!subscriptionId) {
      return;
    }
    if (this.connected && this.client) {
      this.client.unsubscribe(subscriptionId);
    }
  }

  @action
  disconnect() {
    if (!this.client) return;
    this.client.disconnect(() => {
      this.client = null;
    });
    this.connected = false;
    this.startedConnected = false;
  }
}

export default StompInstance;
